module.exports = "<div (click)=\"appBackdropClose()\" [ngClass]=\"{ 'appBackdrop':isApp_BackdropVisible}\"></div>\n"